import React, { useState } from 'react';
import styles from './DropdownGeneral.module.scss';
import { DropdownGeneralProps, OptionType } from './DropdownGeneral.type';
import { Select } from 'antd';

export const ArrowDown = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <mask
      id="mask0_2719_16958"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2719_16958)">
      <path
        d="M12 15.375L6 9.37501L7.4 7.97501L12 12.575L16.6 7.97501L18 9.37501L12 15.375Z"
        fill="#E4E4E4"
      />
    </g>
  </svg>
);

export const ArrowUp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <mask
      id="mask0_2719_6487"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2719_6487)">
      <path
        d="M7.4 15.375L6 13.975L12 7.97501L18 13.975L16.6 15.375L12 10.775L7.4 15.375Z"
        fill="#E4E4E4"
      />
    </g>
  </svg>
);

const DropdownGeneral: React.FC<DropdownGeneralProps> = ({
  defaultValue,
  list,
  style,
  onChange,
  ...rest
}) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <div className={styles['area']} id="area">
      <Select
        data-testid="dropdown-general"
        className={styles['Container']}
        defaultValue={defaultValue}
        style={style}
        onChange={(value: string, option: OptionType | OptionType[]) => {
          setOpen((s) => !s);
          onChange && onChange(value, option);
        }}
        options={list}
        popupMatchSelectWidth={true}
        suffixIcon={open ? <ArrowUp /> : <ArrowDown />}
        getPopupContainer={(trigger) => trigger.parentNode}
        {...rest}
      />
    </div>
  );
};

export default DropdownGeneral;
